import * as actions from './actions';
import * as getters from './getters';
import mutations from './mutations';

export default {
  state() {
    return {
      cmsLists: [],
      cmslistdetailsById: [],
    };
  },
  mutations,
  actions,
  getters,
};
